import { AvvirEvent } from "type_aliases";
import type { ApiPlannedElement } from "avvir";

export type SelectedElementsLoadedEvent = AvvirEvent<typeof SELECTED_ELEMENTS_LOADED, { floorId: string, elements: ApiPlannedElement[] }>

/** The full data for a multi-element selection (eg: a box selection), kept with the floor's element details. */
const selectedElementsLoaded = (floorId: string, elements: ApiPlannedElement[]): SelectedElementsLoadedEvent => ({
  type: SELECTED_ELEMENTS_LOADED,
  payload: {
    floorId,
    elements
  }
});

export const SELECTED_ELEMENTS_LOADED = "selected_elements_loaded";

export default selectedElementsLoaded;
